var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#9A75BB",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.523 15.094A1.138 1.138 0 0 0 4.93 16.58l1.281-.4a.8.8 0 0 1 .602.035c.99.517 2.091.786 3.208.785.495 0 .989-.052 1.473-.152A7.003 7.003 0 0 0 16.115 6.54a7.002 7.002 0 0 0-12.222 6.841.772.772 0 0 1 .032.642l-.402 1.07Zm.52-5.805a6.033 6.033 0 0 1 8.61-4.737 6.035 6.035 0 0 1 1.677 9.681 6.036 6.036 0 0 1-7.065 1.116 1.69 1.69 0 0 0-.78-.188c-.192 0-.381.03-.564.088l-1.281.4a.162.162 0 0 1-.2-.212l.398-1.072a1.742 1.742 0 0 0-.09-1.456A6.019 6.019 0 0 1 4.04 9.29h.003Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.066 8.543a.488.488 0 0 0 .488-.488 1.464 1.464 0 1 1 2.024 1.353 1.737 1.737 0 0 0-1.047 1.627v.924a.488.488 0 0 0 .976 0v-.924a.774.774 0 0 1 .444-.725 2.44 2.44 0 1 0-3.373-2.255.488.488 0 0 0 .488.488Zm1.952 6.018a.65.65 0 1 0 0-1.301.65.65 0 0 0 0 1.301Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.c8eb6c79656f6ee7031223c715c34611.svg";
export { ForwardRef as ReactComponent };